module.exports = __webpack_public_path__ + "static/media/approved.97b7256a.gif";